import { useState, useEffect } from 'react';

interface Props {
  imageSrc: any;
  width: number;
  height: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function LoadingSpinner({ imageSrc, width, height }: Props) {
  const [rotation, setRotation] = useState<number>(0);

  useEffect(() => {
    let requestId: number;

    function animate(): void {
      setRotation((prevRotation) => prevRotation + 1);
      requestId = requestAnimationFrame(animate);
    }

    requestId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(requestId);
    };
  }, []);

  return (
    <img
      src={imageSrc}
      alt="loading"
      style={{
        width,
        height,
        transform: `rotate(${rotation}deg)`,
        position: 'absolute',
        left: '50%',
        top: '50%',
        transformOrigin: 'center',
        marginLeft: -width / 2,
        marginTop: -height / 2
      }}
    />
  );
}

export default LoadingSpinner;
